import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import React from 'react';

import { AccessPointData } from '../../api/types';
import { AccessSituationBanner } from '../AccessSituationBanner/AccessSituationBanner';
import { useHomeData } from '../LoadHomeData/HomeDataProvider';
import { UserDetails } from '../UserDetails/UserDetails';
import { AccessPointCardBackButton } from './AccessPointCardBackButton';

interface AccessPointCardProps {
    Button?: React.ReactNode;
    accessInformation: AccessPointData;
    backButtonTo?: string;
    displayChildren?: boolean;
    children: React.ReactNode;
}

export const AccessPointCard: React.FC<AccessPointCardProps> = ({
    Button,
    accessInformation,
    backButtonTo = '',
    displayChildren = true,
    children,
}) => {
    const { userPicture } = useHomeData();

    return (
        <Box sx={{ maxWidth: 600, margin: 'auto' }}>
            <Card sx={{ boxShadow: 3 }}>
                <CardContent sx={{ padding: 0 }}>
                    {backButtonTo && <AccessPointCardBackButton to={backButtonTo} />}

                    <AccessSituationBanner
                        accessSituation={accessInformation.accessSituation}
                        accessInformation={accessInformation}
                    />

                    <Box sx={{ padding: '0 1rem' }}>
                        <Box>
                            <Box mt={'-4rem'}>
                                <UserDetails
                                    firstName={accessInformation.firstName}
                                    lastName={accessInformation.lastName}
                                    orgUnit={accessInformation.orgUnit}
                                    userPicture={userPicture}
                                />
                            </Box>
                        </Box>

                        {displayChildren ? <Box sx={{ marginTop: '2rem' }}>{children}</Box> : <></>}
                    </Box>
                </CardContent>
            </Card>

            {Button && <CardActions style={{ display: 'none' }}>{Button}</CardActions>}
        </Box>
    );
};
